import { connect } from 'react-redux';
import InventoryPageLayout from '../../../components/inventory/PageLayout';
import { showAddItemSkuModal } from '../../../redux/Inventory/actions/components/item-sku-lookup';
import { fetchInventoryItemsTemplateDownloadUrl } from '../../../redux/Inventory/sagas/item/routines';
import {
  getInventoryItemsTemplateDownloadUrl,
  getIsFetchingInventoryItemsTemplateDownloadUrl
} from '../../../redux/Inventory/selectors/components/page-layout';

function mapStateToProps(state, props) {
  return {
    ...props,
    itemsTemplateDownloadUrl: getInventoryItemsTemplateDownloadUrl(state),
    isFetchingItemsTemplateDownloadUrl: getIsFetchingInventoryItemsTemplateDownloadUrl(
      state
    )
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onShowAddItemSkuModal: () => {
      dispatch(showAddItemSkuModal());
    },
    onDownloadInventoryTemplate: () => {
      dispatch(fetchInventoryItemsTemplateDownloadUrl());
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryPageLayout);
